import { CJEvent } from 'types/event';
import { stripHtmlTags } from 'utils/sortFctReactTable';

export function isCJEventActivitiesEmpty(cjEvent: CJEvent) {
  const linkedFichesDePrep =
    cjEvent.linkedFichesDePrep === null ? [] : cjEvent.linkedFichesDePrep || [];
  const hasImage = (cjEvent.flow || '').includes('<img');
  return (
    !hasImage &&
    stripHtmlTags(cjEvent.flow || '').trim() === '' &&
    (cjEvent.attachments || []).length === 0 &&
    (linkedFichesDePrep || []).length === 0
  );
}
